/**
 * ImagePlate — a framed, desaturated editorial image with optional caption.
 * Signature "museum plate" treatment for v0.2.
 */
export default function ImagePlate({
  src,
  alt = "",
  aspect = "4/5",
  caption,
  captionRight,
  dark = false,
  duotone = true,
  className = "",
  corners = true,
  cornersLight = false,
  loading = "lazy",
  children,
}) {
  return (
    <div
      className={`g1-plate ${dark ? "g1-plate-dark" : ""} ${
        duotone ? "g1-plate-duotone" : ""
      } ${className}`}
      style={{ aspectRatio: aspect }}
    >
      <img
        src={src}
        alt={alt}
        className="g1-plate-img"
        loading={loading}
        decoding="async"
      />
      {children}
      {(caption || captionRight) && (
        <div className="g1-plate-caption">
          <span>{caption}</span>
          {captionRight && <span>{captionRight}</span>}
        </div>
      )}
      {corners && (
        <div className={`g1-corners ${cornersLight ? "g1-corners-light" : ""}`}>
          <span className="tl" />
          <span className="tr" />
          <span className="bl" />
          <span className="br" />
        </div>
      )}
    </div>
  );
}
